// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-Guests-module__guestsContainer__lnzMw";
var _2 = "assets-js-ViewInvitation-components-Guestlist-Guests-module__guestsHeader__V_mrF";
export { _1 as "guestsContainer", _2 as "guestsHeader" }
